import _ from "lodash";
import {PINTEREST_IMAGES_PATH, PINTEREST_SCOPES} from "../constants/pinterest.constant";
import {pinterestConfig} from "../../firebase/client-app";
import axios from "axios";
import qs from "qs";


export {
    initPinterestOAuth,
    getPinterestAccessToken
}

const initPinterestOAuth = () => {
    const queries = `?client_id=${pinterestConfig.appId}&redirect_uri=${pinterestConfig.redirectUrl}&response_type=code&scope=${PINTEREST_SCOPES}`;
    window.open(pinterestConfig.oauthUrl + queries, '_self');
}

async function getPinterestAccessToken(code) {
    const tokenParams = {};

    let data = qs.stringify({
        grant_type: 'authorization_code',
        code: code,
        redirect_uri: pinterestConfig.redirectUrl,
    });

    let config = {
        method: 'post',
        url: pinterestConfig.accessTokenUrl,
        headers: {
            Authorization: `Basic ${btoa(`${pinterestConfig.appId}:${pinterestConfig.appSecretKey}`)}`,
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const response = await axios.request(config);

        return {
            data: response.data,
        };
    } catch (error) {
        console.error('Error getting Pinterest access token:', error.response ? error.response.data : error.message);
        return {error};
    }
}

